module.exports = __webpack_public_path__ + "img/navigate_next_black_24dp.fe65d545.svg";